import { type ReactNode } from 'react'
import { typeClass } from '@utils/typography'

type Props = {
  title: string
  description?: string
  children: ReactNode
}

/** Смысловая часть шага: на шаге их бывает две, и заголовок отделяет одну от другой. */
export const FormBlock = ({ title, description, children }: Props) => (
  <div className="grid gap-4">
    <div className="grid gap-1">
      <h2 className={typeClass.sectionTitle}>{title}</h2>
      {description && <p className={`${typeClass.supporting} text-muted-foreground`}>{description}</p>}
    </div>
    {children}
  </div>
)
